var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 72,
    viewBox: "0 0 180 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3289 22.709H10V48.3775H17.3289C21.1912 48.3775 24.0341 47.4436 26.4781 45.4016C29.4097 42.9608 31.1414 39.3169 31.1414 35.5432C31.097 27.9927 25.4555 22.709 17.3289 22.709ZM23.192 41.9825C21.6376 43.404 19.5956 44.0245 16.3538 44.0245H15.021V27.062H16.3538C19.5956 27.062 21.5489 27.6382 23.192 29.1483C24.9237 30.7027 25.9462 33.0549 25.9462 35.5432C25.9462 37.9872 24.9237 40.4281 23.192 41.9825Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4241 22.709H33.4062V48.3775H38.4241V22.709Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6375 32.571C47.6173 31.4598 46.7752 30.7063 46.7752 29.3292C46.7752 27.7304 48.3296 26.4863 50.5046 26.4863C52.0147 26.4863 53.2145 27.1068 54.5441 28.5725L57.1655 25.1535C55.0349 23.2888 52.4579 22.3105 49.615 22.3105C45.0847 22.3105 41.6213 25.4637 41.6213 29.6394C41.6213 33.1915 43.22 34.9675 47.9276 36.6549C49.8809 37.364 50.9035 37.8104 51.391 38.1207C52.4135 38.7855 52.9011 39.7194 52.9011 40.7863C52.9011 42.8726 51.258 44.3827 49.0388 44.3827C46.6423 44.3827 44.7301 43.1828 43.5777 40.9636L40.3359 44.0724C42.6438 47.4472 45.3981 48.9573 49.2161 48.9573C54.4112 48.9573 58.0519 45.4939 58.0519 40.5204C58.0519 36.4808 56.3645 34.6573 50.6344 32.571H50.6375Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6055 35.5426C59.6055 43.0931 65.5129 48.9087 73.1489 48.9087C75.2795 48.9087 77.1441 48.4655 79.4109 47.3986V41.4912C77.4132 43.4889 75.6372 44.2898 73.3705 44.2898C68.3526 44.2898 64.7563 40.6491 64.7563 35.454C64.7563 30.2589 68.4413 26.6625 73.1489 26.6625C75.5454 26.6625 77.3246 27.5078 79.4109 29.5497V23.6423C77.2359 22.5311 75.4156 22.0879 73.2375 22.0879C65.687 22.1322 59.6055 28.084 59.6055 35.5426Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.061 39.9406L112.223 22.709H106.762L117.684 49.0455H120.349L131.452 22.709H126.035L119.061 39.9406Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.727 48.3775H147.894V44.0276H138.7V37.0976H147.539V32.7478H138.7V27.062H147.894V22.709H133.727V48.3775Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.697 30.3038C167.697 25.5076 164.411 22.709 158.636 22.709H151.219V48.3775H156.237V38.0759H156.901L163.828 48.3775H170.002L161.919 37.5852C165.604 36.7874 167.694 34.2104 167.694 30.3038H167.697ZM157.661 34.5238H156.195V26.7517H157.75C160.859 26.7517 162.546 28.0402 162.546 30.5697C162.546 33.0992 160.859 34.5207 157.661 34.5207V34.5238Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6867 49.2641C102.215 49.2641 108.319 43.1608 108.319 35.632C108.319 28.1033 102.215 22 94.6867 22C87.158 22 81.0547 28.1033 81.0547 35.632C81.0547 43.1608 87.158 49.2641 94.6867 49.2641Z",
    fill: "url(#paint0_linear_17758_81118)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M94.6867 49.2641C102.215 49.2641 108.319 43.1608 108.319 35.632C108.319 28.1033 102.215 22 94.6867 22C87.158 22 81.0547 28.1033 81.0547 35.632C81.0547 43.1608 87.158 49.2641 94.6867 49.2641Z",
    fill: "url(#paint1_linear_17758_81118)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17758_81118",
    x1: 101.674,
    y1: 46.5731,
    x2: 92.2269,
    y2: 31.7792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F79A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F68D20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F58720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F48120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17758_81118",
    x1: 100.183,
    y1: 46.3705,
    x2: 86.3733,
    y2: 19.3819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#E16F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D4602C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#D05B2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverCard);
export default __webpack_public_path__ + "static/media/discover_card.8ac8858b2642999ab9c48f17bbc23f2d.svg";
export { ForwardRef as ReactComponent };